import './App.css';
import { Provider } from "react-redux";
import store from "./redux/store";
import MainRoutes from './app/Route';

function App() {
  return (
    // <ToastContainer>
    // {/* Provide Redux store  */}
    <Provider store={store}>
      <MainRoutes />
    </Provider>
  );
}

export default App;
